import { render } from "./shareArticle.vue?vue&type=template&id=6cf576bf&scoped=true"
import script from "./shareArticle.vue?vue&type=script&lang=js"
export * from "./shareArticle.vue?vue&type=script&lang=js"

import "./shareArticle.vue?vue&type=style&index=0&id=6cf576bf&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf576bf"]])

export default __exports__